import React from 'react'
import PropTypes from 'prop-types'
import { styled, Icon } from '@deseretbook/react-ui'

const StyledStepNumber = styled('div')(({
  theme, isActive, isDisabled, number,
}) => {
  let color = theme.palette.primary.main
  let background = theme.palette.background.main
  let borderColor = color

  let content = {}

  if (isActive) {
    color = theme.palette.primary.mainText
    background = theme.palette.primary.main
    borderColor = background
  }

  if (isDisabled) {
    color = theme.typography.light.disabled
    background = theme.palette.background.alternate
    borderColor = color
  }

  if (isDisabled || isActive) {
    content = {
      '&:before': {
        content: `"${number}"`,
      },
    }
  }

  return {
    label: 'StepNumber',
    ...theme.typography.base,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: theme.spacing.use(2),
    height: theme.spacing.use(2),
    color,
    background,
    borderColor,
    borderWidth: '1px',
    borderStyle: 'solid',
    borderRadius: '5000px',
    ...content,
  }
})

/**
 * Step number used to indicate order/completion of a step in the checkout flow.
 *
 * @param {object} props - component props
 * @returns {function} Component
 */
const StepNumber = (props) => {
  if (props.isDisabled || props.isActive) {
    return <StyledStepNumber {...props} />
  }

  return (
    <StyledStepNumber {...props}>
      <Icon name="check" />
    </StyledStepNumber>
  )
}

StepNumber.propTypes = {
  isDisabled: PropTypes.bool,
  isActive: PropTypes.bool,
}

StepNumber.defaultProps = {
  isDisabled: false,
  isActive: false,
}

export default StepNumber
